import { createTheme } from "@mui/material";

const PLAY_FONT = "Play, Arial, sans-serif";
const BODY_FONT = "Futura, Trebuchet MS, Arial, sans-serif";

let Theme = createTheme();
export const theme = createTheme(Theme, {
  palette: {
    primary: {
      main: "#4EAD87",
    },
    background: {
      default: "#141414",
    },
  },
  components: {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
      },
    },
    MuiTabs: {
      defaultProps: {
        selectionFollowsFocus: true,
        textColor: "secondary",
        indicatorColor: "secondary",
      },
      styleOverrides: {
        indicator: {
          "&.MuiTabs-indicator": {
            display: "none",
          },
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            background: "#7e57c2",
            borderRadius: "24px",
            color: "white",
          },
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        h1: { fontFamily: PLAY_FONT },
        h2: { fontFamily: PLAY_FONT },
        h3: { fontFamily: PLAY_FONT },
        h4: { fontFamily: PLAY_FONT },
        h5: { fontFamily: PLAY_FONT },
        h6: { fontFamily: PLAY_FONT },
      },
    },
  },

  typography: {
    fontFamily: BODY_FONT,
    h1: {
      color: "#fff",
      fontFamily: PLAY_FONT,
      [Theme.breakpoints.down("sm")]: {
        fontSize: "25px",
      },
    },
    h2: {
      fontSize: "42px",
      lineHeight: "40px",
      fontWeight: 700,
      color: "#fff",
      fontFamily: PLAY_FONT,
      [Theme.breakpoints.down("sm")]: {
        fontSize: "25px",
      },
    },
    h3: {
      fontSize: "32px",
      lineHeight: "32px",
      fontWeight: 700,
      color: "#fff",
      fontFamily: PLAY_FONT,
      [Theme.breakpoints.down("sm")]: {
        fontSize: "22px",
      },
    },
    h4: {
      fontSize: "20px",
      lineHeight: "24px",
      fontWeight: 400,
      color: "#fff",
      fontFamily: PLAY_FONT,
      [Theme.breakpoints.down("sm")]: {
        fontSize: "15px",
      },
    },
    h5: {
      fontSize: "16px",
      lineHeight: "18px",
      fontWeight: 500,
      color: "#fff",
      fontFamily: PLAY_FONT,
      [Theme.breakpoints.down("sm")]: {
        fontSize: "10px",
      },
    },
    h6: {
      fontSize: "12px",
      lineHeight: "18px",
      fontWeight: 500,
      color: "#fff",
      fontFamily: PLAY_FONT,
      [Theme.breakpoints.down("sm")]: {
        fontSize: "10px",
      },
    },
    h7: {
      fontSize: "32px",
      lineHeight: "38px",
      fontWeight: 650,
      color: "#777777",
      fontFamily: PLAY_FONT,
      [Theme.breakpoints.down("sm")]: {
        fontSize: "22px",
      },
    },
    h8: {
      fontSize: "24px",
      lineHeight: "38px",
      fontWeight: 650,
      color: "#777777",
      fontFamily: PLAY_FONT,
      [Theme.breakpoints.down("sm")]: {
        fontSize: "16px",
      },
    },
    box: {
      fontSize: "16px",
      lineHeight: "19.18px",
      fontWeight: 400,
      color: "#777777",
      fontFamily: BODY_FONT,
      [Theme.breakpoints.down("sm")]: {
        fontSize: "12px",
      },
    },
    checkbox: {
      fontSize: "18px",
      lineHeight: "22px",
      fontWeight: 400,
      color: "#777777",
      fontFamily: BODY_FONT,
      [Theme.breakpoints.down("sm")]: {
        fontSize: "9px",
        fontWeight: 200,
      },
    },
    btn: {
      fontSize: "20px",
      lineHeight: "20px",
      fontWeight: 700,
      color: "#fff",
      fontFamily: BODY_FONT,
      [Theme.breakpoints.down("sm")]: {
        fontSize: "15px",
        fontWeight: 500,
      },
    },
  },
});

export const TITLE_FONT = PLAY_FONT;
